import { Component, inject, input, model, output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoBuyerFormComponent } from '../co-buyer-form/co-buyer-form.component';
import { SvgIconsComponent } from '@zayan-erp/shared';
import { Subject } from 'rxjs';

@Component({
  selector: 'add-co-buyer-modal',
  imports: [CoBuyerFormComponent, SvgIconsComponent],
  templateUrl: './add-co-buyer-modal.component.html'
})
export class AddCoBuyerModalComponent {
  readonly #modalService = inject(NgbModal);

  readonly prospectId = input.required<string>({ alias: 'prospectIdInput' });
  readonly selectedCoBuyerId = model<string | null>(null, { alias: 'selectedCoBuyerInput' });
  readonly reload = output<void>();

  readonly #onSubmitSubject = new Subject<void>();
  readonly onSubmitObservable = this.#onSubmitSubject.asObservable();

  closeModal(): void {
    this.selectedCoBuyerId.set(null);
    this.#modalService.dismissAll();
  }

  onSaveClick(): void {
    this.#onSubmitSubject.next();
  }

  onReload(): void {
    this.reload.emit();
    this.closeModal();
  }
}
